import { Camera } from "lucide-react";
import { projects } from "@/data/siteConfig";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { ProjectCard } from "@/components/ProjectCard";
import { ContactCTA } from "@/components/home/ContactCTA";
import { RevealGroup, RevealItem } from "@/components/Reveal";

export default function OurWork() {
  return (
    <>
      <Seo
        title="Our Work — Recent Projects"
        description="A portfolio of locksmith and safe projects by Velasco Lock and Safe across Southern California — safe openings, heavy safe moves, installations and more."
        path="/our-work"
      />
      <PageHero
        overline="Our Work"
        title="Recent projects & completed work"
        description="A growing portfolio of locksmith and safe projects across Southern California."
      />

      <section className="bg-ink py-24 md:py-28">
        <div className="mx-auto max-w-[1440px] px-5 md:px-8">
          <div className="mb-12 flex items-start gap-3 border border-white/10 bg-ink-surface p-5">
            <Camera className="mt-0.5 h-5 w-5 shrink-0 text-gold" />
            <p className="text-sm leading-relaxed text-steel">
              Real project photos and videos are being added here. The cards below show
              how each completed job will be presented — with multiple photos, optional
              video and before/after images. Tap any project to preview the gallery layout.
            </p>
          </div>

          <RevealGroup className="grid gap-x-6 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
            {projects.map((p) => (
              <RevealItem key={p.id}>
                <ProjectCard project={p} />
              </RevealItem>
            ))}
          </RevealGroup>
        </div>
      </section>

      <ContactCTA />
    </>
  );
}
